import PurchaseConfirmAnnouncement from '@/components/purchase-confirm-announcement/purchase-confirm-announcement.vue';
import { successMessage, errorMessage } from '@/utils/message.js';
import PurchaseAgreement from './purchase-agreement/index.vue';
import PurchaseBusinessService from '../../purchase-business-service';
import UpdateConfirmInfo from '@/components/update-confirm-info/update-confirm-info.vue';
const debounce = require('lodash.debounce');
import { isPurchaseTypeFlag } from '@/utils/common.js';
export default {
  components: {
    PurchaseConfirmAnnouncement,
    UpdateConfirmInfo,
    PurchaseAgreement
  },
  data() {
    return {
      purchaseInfo: {},
      userInfo: {},
      updateConfirmData: {},
      showConfirm: false,
      disabled: false,
      checkboxFlag: false,
      showAgreement: false,
      dialogFormVisible: false,
      ruleForm: {
        refuseReason: ''
      },
      rules: {
        refuseReason: [
          { required: true, message: '请输入100字以内的驳回原因', trigger: 'change' }
        ]
      }
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getPurchaseProjectDetail('PURCHASE'); // 获取采购信息
    this.getPurchaseProjectDetail('USER'); // 获取用户和项目联系人信息
  },
  computed: {
  },
  methods: {
    isPurchaseTypeFlag,
    // 勾选 确认公告
    checkboxChange() {
      this.disabled = !this.checkboxFlag;
    },
    // 获取采购详情
    getPurchaseProjectDetail(echoCode) {
      PurchaseBusinessService.getPurchaseProjectDetail({ purchaseId: this.id, echoCode: echoCode }).then(res => {
        if (res.code === '0') {
          if (echoCode === 'PURCHASE') {
            this.purchaseInfo = res.data;
            if (this.isPurchaseTypeFlag(this.purchaseInfo.purchaseType)) {
              this.disabled = true;
            }
          } else {
            this.userInfo = res.data;
          }
        }
      });
    },
    goBack() {
      this.$router.back();
    },
    // 驳回公告
    dialogFormclick() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$confirm('驳回公告后需要再次创建公告信息，确定要驳回公告吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit();
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    },

    // 驳回公告提交
    submit() {
      let params =  {
        projectId: this.id,
        type: 2,
        remark: this.ruleForm.refuseReason
      };
      this.dialogFormVisible = false;
      PurchaseBusinessService.rejectAnnouncement(params).then(res => {
        if (res && res.code === '0') {
          successMessage('驳回公告信息成功');
          this.$router.back();
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('驳回公告信息失败');
        }
      });
    },
    confirmPurchase: debounce(function () {
      this.$confirm('确定要确认公告信息？确认后不可撤回', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        PurchaseBusinessService.checkConfirmPurchase(this.id).then(res => {
          this.disabled = true;
          if (res && res.code === '0') {
            // console.log(res);
            if (res.data) {
              if (res.data.isShow) {
                // 时间过期，打开更改确认公告信息弹出
                this.showConfirm = true;
                this.updateConfirmData = res.data;
              } else {
                // 没过期的话，直接执行确认公告事件
                this.confirmEven();
              }
            }
          } else if (res && res.reason) {
            this.disabled = false;
            errorMessage(res && res.reason);
          } else {
            this.disabled = false;
            errorMessage('确认公告失败');
          }
        }, (error) => {
          this.disabled = false;
          if (error && error.data && error.data.reason) {
            errorMessage(error.data.reason);
          }
        });
      }).catch(() => {
        this.disabled = false;
      });
    }, 2000, {
      'leading': true,
      'trailing': false
    }),
    // 确认公告事件
    confirmEven() {
      PurchaseBusinessService.confirmPurchase(this.id).then(res => {
        this.disabled = true;
        if (res.code === '0') {
          this.showConfirm = false;
          successMessage('确认公告成功');
          this.$router.back();
        } else if (res && res.reason) {
          this.disabled = true;
          errorMessage(res.reason);
        } else {
          this.disabled = true;
          errorMessage('确认公告失败');
        }
      }, error => {
        this.disabled = false;
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('确认公告失败');
        }
      });
    }
  }
};
